import { PropsWithChildren } from 'react'

import { Header } from '../Header'

export function Layout({ children }: PropsWithChildren) {
  return (
    <div className="h-screen bg-off-white pt-[30px]">
      <div className="mb-[30px]">
        <Header />
      </div>
      <div className="mx-auto">{children}</div>
    </div>
  )
}
